var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_2047",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 53,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.19238,
    y: 4.18848,
    width: 52.6166,
    height: 52.6166,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_2047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.192383,
    y: -0.196289,
    width: 61.386,
    height: 61.386,
    fill: "url(#pattern0)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5205,
    y: 2,
    width: 5.48089,
    height: 1.09618,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.002,
    y: 2,
    width: 5.48089,
    height: 1.09618,
    transform: "rotate(90 59.002 2)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(-1 0 0 1 7.48145 2)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 2 2)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48145,
    y: 59,
    width: 5.48089,
    height: 1.09618,
    transform: "rotate(180 7.48145 59)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 59,
    width: 5.48089,
    height: 1.09618,
    transform: "rotate(-90 2 59)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 53.5205 59)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 59.002 59)",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_247_2047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.5205,
    y: 2,
    width: 5.48089,
    height: 1.09618,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.002,
    y: 2,
    width: 5.48089,
    height: 1.09618,
    transform: "rotate(90 59.002 2)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_247_2047)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(-1 0 0 1 7.48145 2)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 2 2)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_247_2047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.48145,
    y: 59,
    width: 5.48089,
    height: 1.09618,
    transform: "rotate(180 7.48145 59)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 59,
    width: 5.48089,
    height: 1.09618,
    transform: "rotate(-90 2 59)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_247_2047)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 53.5205 59)",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_247_2047)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.48089,
    height: 1.09618,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 59.002 59)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_247_2047",
    transform: "scale(0.00290698)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_247_2047",
    x: 51.5205,
    y: 0,
    width: 9.48145,
    height: 9.48047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_247_2047"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_247_2047",
    x: 0,
    y: 0,
    width: 9.48145,
    height: 9.48047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_247_2047"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_247_2047",
    x: 0,
    y: 51.5195,
    width: 9.48145,
    height: 9.48047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_247_2047"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_247_2047",
    x: 51.5205,
    y: 55.9043,
    width: 9.48047,
    height: 5.0957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_247_2047"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_247_2047",
    x: 55.9062,
    y: 51.5195,
    width: 5.0957,
    height: 9.48047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_247_2047"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_247_2047",
    width: 344,
    height: 344,
    xlinkHref: "data:image/jpeg;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.90fda7251d402063ede6ccfc547f5145.svg";
export { ForwardRef as ReactComponent };